// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mQJ-","tabsBox":"styles_tabsBox__3QeHZ","createButton":"styles_createButton__1IXGm"};